module.exports = __webpack_public_path__ + "img/thumb_Atelier_8.4d993ac6.jpg";